var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHandLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0005 7C21.0005 5.62 19.8805 4.5 18.5005 4.5C18.3305 4.5 18.1605 4.5 18.0005 4.55V4C18.0005 2.62 16.8805 1.5 15.5005 1.5C15.2705 1.5 15.0405 1.53 14.8305 1.59C14.4605 0.66 13.5605 0 12.5005 0C11.2705 0 10.2505 0.89 10.0405 2.06C9.87046 2 9.69046 2 9.50046 2C8.12046 2 7.00046 3.12 7.00046 4.5V10.39C6.66046 10.08 6.24046 9.85 5.78046 9.73L5.00046 9.5C4.18046 9.29 3.31046 9.61 2.82046 10.35C2.44046 10.92 2.42046 11.66 2.67046 12.3L5.23046 18.73C6.50046 21.91 9.57046 24 13.0005 24C17.4205 24 21.0005 20.42 21.0005 16V7ZM19.0005 16C19.0005 19.31 16.3105 22 13.0005 22C10.3905 22 8.05046 20.41 7.09046 18L4.50046 11.45L5.00046 11.59C5.50046 11.71 5.85046 12.05 6.00046 12.5L7.00046 15H9.00046V4.5C9.00046 4.22 9.22046 4 9.50046 4C9.78046 4 10.0005 4.22 10.0005 4.5V12H12.0005V2.5C12.0005 2.22 12.2205 2 12.5005 2C12.7805 2 13.0005 2.22 13.0005 2.5V12H15.0005V4C15.0005 3.72 15.2205 3.5 15.5005 3.5C15.7805 3.5 16.0005 3.72 16.0005 4V12H18.0005V7C18.0005 6.72 18.2205 6.5 18.5005 6.5C18.7805 6.5 19.0005 6.72 19.0005 7V16Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandLight);
export default __webpack_public_path__ + "static/media/hand_light.d38fe80c.svg";
export { ForwardRef as ReactComponent };